module.exports = __webpack_public_path__ + "img/z (19).dc2a8cb5.png";